"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeader = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const react_draggable_1 = __importDefault(require("react-draggable"));
const react_intl_1 = require("react-intl");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const ArrowDropDown_1 = __importDefault(require("@material-ui/icons/ArrowDropDown"));
const checkbox_1 = require("../../components/checkbox/checkbox");
const table_styles_1 = require("./table-styles");
const table_context_1 = require("./table-context");
const use_scrollbar_size_1 = require("../../utils/use-scrollbar-size");
const tooltip_1 = require("../../components/tooltip/tooltip");
exports.TableHeader = react_1.forwardRef(function TableHeader(_, ref) {
    const classes = table_styles_1.useStyles();
    const { filteredColumns, sorts, setColumnsState, columns, columnsState, toggleSortColumn, toggleAllRowSelection, showSelectBox, } = react_1.useContext(table_context_1.TableContext);
    const { selected } = react_1.useContext(table_context_1.TableSelectedContext);
    const setColumnWidth = event_callback_hook_1.useEventCallback((datakey, width) => {
        var _a;
        const index = columnsState.findIndex((column) => column.datakey === datakey);
        if (index !== -1) {
            setColumnsState([
                ...columnsState.slice(0, index),
                {
                    ...columnsState[index],
                    width: Math.max((_a = columns[index].minWidth) !== null && _a !== void 0 ? _a : 50, width),
                },
                ...columnsState.slice(index + 1, undefined),
            ]);
        }
    });
    const handleHeaderClick = event_callback_hook_1.useEventCallback((column) => {
        if (column.sortable) {
            toggleSortColumn(column.datakey);
        }
    });
    const size = use_scrollbar_size_1.useScrollBarSize();
    return (react_1.default.createElement("div", { ref: ref, className: classes.header },
        react_1.default.createElement("div", { style: { width: size } }),
        showSelectBox && (react_1.default.createElement(tooltip_1.Tooltip, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_SELECT_ALL", defaultMessage: "V\u00FDb\u011Br polo\u017Eek slou\u017E\u00ED jako vstup pro hromadn\u00E9 operace (nap\u0159. tisk)" }), placement: "top-start" },
            react_1.default.createElement("div", { className: classes.tableRowActions },
                react_1.default.createElement(checkbox_1.Checkbox, { highlighted: false, value: selected.length > 0, onChange: toggleAllRowSelection })))),
        filteredColumns.map((column, i) => {
            const { name, datakey } = column;
            const sortIndex = sorts.findIndex((sort) => sort.datakey === datakey);
            const sort = sortIndex !== -1 ? sorts[sortIndex] : undefined;
            return (react_1.default.createElement("div", { key: `${datakey}-${i}`, className: clsx_1.default(classes.tableRowHeader, {
                    [classes.sortable]: column.sortable,
                }), style: { width: column.width }, onClick: () => handleHeaderClick(column) },
                react_1.default.createElement(Typography_1.default, { className: classes.tableRowHeaderLabel, variant: "h6" }, name),
                sort && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(ArrowDropDown_1.default, { classes: {
                            root: sort.order === 'ASC' ? classes.iconRotate : '',
                        } }),
                    react_1.default.createElement(Typography_1.default, { variant: "h6", className: classes.sortSup }, sortIndex + 1))),
                react_1.default.createElement("div", { className: clsx_1.default(classes.draggable, classes.headerCellDraggable), onClick: (event) => event.stopPropagation() },
                    react_1.default.createElement(react_draggable_1.default, { axis: "x", defaultClassNameDragging: classes.draggable, onStop: (_, { x }) => setColumnWidth(datakey, column.width + x), position: { x: 0, y: 0 } },
                        react_1.default.createElement("div", { className: classes.draggableIcon }, "\u22EE")))));
        })));
});
//# sourceMappingURL=table-header.js.map